import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  mlsProvider: null,
  mlsProviders: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const mlsProviderReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.MLSPROVIDER_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.MLSPROVIDER_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.MLSPROVIDER_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default mlsProviderReducer;
